import './list-visor-filter-pill.scss';

import ListVisorFilterPill from './ListVisorFilterPill';

export default ListVisorFilterPill;
